/**
 * Created by anthony on 7/3/14.
 */

/**
 * Created by anthony on 7/7/14.
 */
var budgetsModel = angular.module('budgetsModel', []);
budgetsModel.factory('BudgetsModelFactory', function(AppModelFactory, AbstractModelService, ApplicationService){
    var BudgetsModel = function(){
        this.endpoint = "/budgets";
    }
    BudgetsModel.prototype = new AppModelFactory();
    BudgetsModel.prototype.parent = AppModelFactory.prototype;
    /*
    BudgetsModel.prototype.put = function(id, data, instance)
    {
        return AbstractModelService.put(this.getEndpoint(id), data, instance);
    }
    */
    BudgetsModel.prototype.getFromApp = function(id, instance)
    {
        return AbstractModelService.get("api/app/"+id+"/budgets", instance);
    }
    BudgetsModel.prototype.purge = function(id, data, instance)
    {
        return AbstractModelService.purge("api/app/"+ApplicationService.getAwardData().app[0].applicationID+"/budgets/"+data.recordID, data, instance);
    }

    return BudgetsModel;
});
budgetsModel.service('BudgetsModelService', function(BudgetsModelFactory){
    var budgetsModel = new BudgetsModelFactory();
    return budgetsModel;
});
